import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";

import Home            from "./pages/Home";
import Restaurants     from "./pages/Restaurants";
import RestaurantMenu  from "./pages/RestaurantMenu";
import Cart            from "./pages/Cart";
import Checkout        from "./pages/Checkout";
import Login           from "./pages/Login";
import OrdersPage      from "./pages/OrdersPage";
import ProfilePage     from "./pages/profile";
import GroceryPage     from "./pages/Grocerypage";
import CourierPage     from "./pages/Courierpage";

// ── Policy Pages ──────────────────────────────────
import TermsAndConditions from "./pages/policies/TermsAndConditions";
import RefundPolicy       from "./pages/policies/RefundPolicy";
import PrivacyPolicy      from "./pages/policies/PrivacyPolicy";
import ReturnPolicy       from "./pages/policies/ReturnPolicy";
import ShippingPolicy     from "./pages/policies/ShippingPolicy";
import AboutUs            from "./pages/policies/AboutUs";
import ContactUs          from "./pages/policies/ContactUs";

// ── Protected Route ───────────────────────────────
function RequireAuth({ children }) {
  const { isLoggedIn, loading } = useAuth();
  const location = useLocation();

  if (loading) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"100vh", fontFamily:"sans-serif", color:"#f97316", fontSize:"1.2rem", fontWeight:700 }}>
      Loading...
    </div>
  );

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}

// ── Routes ────────────────────────────────────────
function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/"               element={<Home />} />
      <Route path="/restaurants"    element={<Restaurants />} />
      <Route path="/restaurant/:id" element={<RestaurantMenu />} />
      <Route path="/cart"           element={<Cart />} />
      <Route path="/grocery"        element={<GroceryPage />} />
      <Route path="/login"          element={<Login />} />
      <Route path="/courier"        element={<CourierPage />} />

      {/* Policy Pages — public, no auth needed */}
      <Route path="/terms"           element={<TermsAndConditions />} />
      <Route path="/refund-policy"   element={<RefundPolicy />} />
      <Route path="/privacy-policy"  element={<PrivacyPolicy />} />
      <Route path="/return-policy"   element={<ReturnPolicy />} />
      <Route path="/shipping-policy" element={<ShippingPolicy />} />
      <Route path="/about"           element={<AboutUs />} />
      <Route path="/contact"         element={<ContactUs />} />

      {/* Protected */}
      <Route path="/checkout" element={<RequireAuth><Checkout /></RequireAuth>} />
      <Route path="/orders"   element={<RequireAuth><OrdersPage /></RequireAuth>} />
      <Route path="/profile"  element={<RequireAuth><ProfilePage /></RequireAuth>} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRoutes />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}